import axios from 'axios'
export function uploadAxios (params, fileType = 2) {
  let formData1 = new FormData()

  formData1.append('file', params.file)
  return axios({
    url: '/web/file/upload?fileType=' + fileType,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData1
    // responseType: 'blob'
  })
}

export function uploadAxiosPath (params, fileType = 2) {
  let formData1 = new FormData()

  formData1.append('file', params.file)
  return axios({
    url: '/web/file/uploadPath?fileType=' + fileType,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData1
    // responseType: 'blob'
  })
}

const downloadFile = function (content, filename) {
  let a = document.createElement('a')
  const blob = new Blob([content])
  const url = window.URL.createObjectURL(blob)
  a.href = url
  a.download = filename
  a.click()
  window.URL.revokeObjectURL(url)
}
export function downloadImgFile (key) {
  return axios({
    url: 'web/file/download/' + key,
    method: 'get',
    headers: {
      Accept: 'application/json;charset=UTF-8'
      // 'Content-Type': 'multipart/form-data'
    },
    data: '',
    responseType: 'blob'
  })
}

export function downloadAxios (key) {
  axios({
    url: 'web/file/download/' + key,
    method: 'get',
    headers: {
      Accept: 'application/json;charset=UTF-8'
      // 'Content-Type': 'multipart/form-data'
    },
    data: '',
    responseType: 'blob'
  }).then(res => {
    console.log(res, 'resssss***********')
    downloadFile1(res)
  })
}
function downloadFile1 (response, name = '') {
  let blob, fileName

  // 文件流对象检测
  if (Object.prototype.toString.call(response.data).includes('Blob')) {
    // 如果是json数据则不下载
    if (response.data.type == 'application/json') return

    blob = response.data
  } else {
    blob = new Blob([response.data])
  }

  // 文件名处理
  if (!name) {
    let disposition = response.headers['content-disposition']
    name = disposition.replace('attachment;filename=', '')
    // fileName = decodeURI(name)
    console.log(name,"name")
    fileName = decodeURIComponent(name)
    console.log(fileName,"fileName")
  } else {
    fileName = name
  }

  if (window.navigator.msSaveBlob) {
    // 这个是IE浏览器独有的方法，用来判断当时是不是IE浏览器
    window.navigator.msSaveBlob(blob, fileName) // 此方法即可下载成功
  } else {
    // 谷歌浏览器 创建a标签 添加download属性下载
    let element = document.createElement('a')
    const url = window.URL.createObjectURL(blob)
    element.href = url
    element.download = fileName
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
    window.URL.revokeObjectURL(url)
  }
}



// WEBPACK FOOTER //
// ./src/utils/uploadDownloadFile.js